export default {
  'CHANGE_ACCOUNTS' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/plans/mutations.js